import config from "../config.js";
import api from "../services/api";

// ✅ Register Service Worker + Push
export const registerSW = async () => {
    try {
        console.log("🟢 Registering service worker...");

        if (!("serviceWorker" in navigator)) {
            console.error("❌ Service workers not supported");
            return;
        }

        if (!("PushManager" in window)) {
            console.error("❌ Push notifications not supported");
            return;
        }

        // 🔐 Ask permission
        const permission = await Notification.requestPermission();
        console.log("🔐 Permission:", permission);

        if (permission !== "granted") {
            console.log("❌ Notification permission denied");
            return;
        }

        // ✅ Register SW
        const registration = await navigator.serviceWorker.register("/serviceworker.js");
        console.log("✅ Service worker registered:", registration);

        // ✅ Wait until ready
        const swReady = await navigator.serviceWorker.ready;

        // 🔍 Check existing subscription
        const existingSubscription = await swReady.pushManager.getSubscription();

        if (existingSubscription) {
            console.log("ℹ️ Already subscribed");
            return existingSubscription;
        }

        console.log("🔐 Subscribing to PushManager...");

        // ✅ Subscribe
        const subscription = await swReady.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(config.VAPID_publicKey),
        });

        console.log("📬 Subscription created:", subscription);

        // ✅ Send to backend
        try {
            const res = await api({
                url: `/pushSubscription/subscribe`,
                method: "POST",
                responseType: "json",
                data: { subscription },
            });

            if (res.code === 200) {
                console.log("✅ Subscription saved to backend");
            } else {
                console.warn("⚠️ Backend response not OK");
            }
        } catch (err) {
            console.error("❌ Failed to send subscription:", err);
        }

        return subscription;
    } catch (err) {
        console.error("❌ Error in registerSW:", err);
    }
};

// ✅ Utility: VAPID key conversion
export const urlBase64ToUint8Array = (base64String) => {
    try {
        const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

        const rawData = atob(base64);

        return new Uint8Array([...rawData].map((char) => char.charCodeAt(0)));
    } catch (err) {
        console.error("❌ Error converting VAPID key:", err);
        return null;
    }
};
